export default __webpack_public_path__ + "static/media/cp3.6dc93aa2.jpg";